import SectionHead from "@/components/SectionHead";
import { XCircle, CheckCircle2 } from "lucide-react";
import { useLang } from "@/i18n";

const BeforeAfter = () => {
  const t = useLang().t;
  return (
  <section data-testid="before-after" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="before-after-head"
        eyebrow={t.beforeAfter.eyebrow}
        title={t.beforeAfter.title}
      />
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <div data-testid="before-column" className="rounded-2xl border border-[#EFEBE4] bg-[#F5F2EB] p-6 sm:p-8">
          <h3 className="font-heading text-xl font-bold text-[#8D6E63]">{t.beforeAfter.without}</h3>
          <ul className="mt-5 space-y-4">
            {t.beforeAfter.withoutItems.map((w) => (
              <li key={w} className="flex items-start gap-3 text-sm sm:text-base text-[#5D4037]">
                <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A48B]" /> {w}
              </li>
            ))}
          </ul>
        </div>
        <div data-testid="after-column" className="rounded-2xl border border-[#A88667] bg-white p-6 sm:p-8 shadow-md">
          <h3 className="font-heading text-xl font-bold text-[#3E2723]">{t.beforeAfter.with}</h3>
          <ul className="mt-5 space-y-4">
            {t.beforeAfter.withItems.map((w) => (
              <li key={w} className="flex items-start gap-3 text-sm sm:text-base font-medium text-[#3E2723]">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#A88667]" /> {w}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
  );
};

export default BeforeAfter;
